export const initiateProgramEnrollmentDefault = '{\n' +
    '    "customerId": "",\n' +
    '    "drugId": "",\n' +
    '    "legacyAddressId": "",\n' +
    '    "personId": "",\n' +
    '    "programName": "",\n' +
    '    "profileId": "",\n' +
    '    "scheduleFrequency": "",\n' +
    '    "intervalDays": ""\n' +
    '}';

export const initiateProgramEnrollmentConcessionsDefault = '{\n' +
    '    "customerId": "",\n' +
    '    "drugId": "",\n' +
    '    "legacyAddressId": "",\n' +
    '    "personId": "",\n' +
    '    "programName": "AP_CONCESSIONS",\n' +
    '    "profileId": "",\n' +
    '    "concessionsReason": "",\n' +
    '    "concessionsFeatures": {\n' +
    '        "concessionType": "",\n' +
    '        "concessionCategory": ""\n' +
    '    },\n' +
    '    "originalOrderContext": {\n' +
    '        "orderId": "",\n' +
    '        "purchaseId": ""\n' +
    '    }\n' +
    '}';

export interface IConcessionsFeatures {
    concessionType: string;
    concessionCategory: string;
}

export interface IOriginalOrderContext {
    orderId: string;
    purchaseId: string;
}

export interface IInitiateProgramEnrollmentRequest {
    customerId: string;
    drugId: string;
    legacyAddressId: string;
    personId: string;
    programName: string;
    profileId: string;
    scheduleFrequency?: string;
    intervalDays?: number;
    concessionsReason?: string;
    concessionsFeatures?: IConcessionsFeatures;
    originalOrderContext?: IOriginalOrderContext;
}
